import React from 'react';

const EditLoader = props => {
    const {visible = true, lightStyle = false, spacing= false} = props;

    if (!visible) {
        return null;
    }

    return <div className={'ch-icon-pulse ch-loader' + (lightStyle ? ' ch-loader-spinner-light' : '') + (spacing ? ' ch-loader-spacing' : '')}>
            <svg height="28px" viewBox="0 -960 960 960" width="28px" fill="#000">
                <path
                    d="M280-420q25 0 42.5-17.5T340-480q0-25-17.5-42.5T280-540q-25 0-42.5 17.5T220-480q0 25 17.5 42.5T280-420Zm200 0q25 0 42.5-17.5T540-480q0-25-17.5-42.5T480-540q-25 0-42.5 17.5T420-480q0 25 17.5 42.5T480-420Zm200 0q25 0 42.5-17.5T740-480q0-25-17.5-42.5T680-540q-25 0-42.5 17.5T620-480q0 25 17.5 42.5T680-420ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
            </svg>
        </div>
}


export default EditLoader;